<template>
    <div :class="cssClass" @click="$emit('click')">
        <main class="current-component">
            <div class="min-width-on-hide" ref="main" :style="getMinWidth">
                <slot name="main"></slot>
            </div>
            <span v-if="expandable" class="js-hide-current-component" title="Скрыть" @click="hideClick">
                <icon-hide/>
            </span>
        </main>
        <div class="leaving-box-component">
            <slot name="leaving"></slot>
            <span class="js-hide-leaving-component" title="Закрыть" @click="closeClick">
                <icon-base width="14" height="14" view-box="0 0 14 14" icon-name="Закрыть"><icon-close/></icon-base>
            </span>
        </div>
    </div>
</template>

<script>
    import IconBase from "./IconBase";
    import IconClose from "./icons/IconClose";
    import IconHide from "./icons/IconHide";
    export default {
        name: 'living-box-component',
        components: {
            IconBase,
            IconClose,
            IconHide,
        },
        props: {
            active: Boolean,
            fullScreen: Boolean,
            closeAction: Function,
            expandable: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                vsMinW: 0
            }
        },
        computed: {
            cssClass() {
                let appClass = 'components-view has-leaving-component';
                if (this.active){
                    appClass += ' leaving-component-visible';
                    appClass += this.fullScreen ? ' current-component-hide' : '';
                }
                return appClass;
            },
            getMinWidth() {
                return 'min-width:' + this.vsMinW + 'px'
            }
        },
        methods: {
            closeClick() {
                this.$emit('update:active', false)
            },
            hideClick() {
                if (!this.fullScreen) {
                    this.vsMinW = this.$refs.main.clientWidth;
                } else {
                    setTimeout(() => {
                        this.vsMinW = 0;
                    }, 310);
                }
                this.$emit('update:full-screen')
            },
        },
    }
</script>

<style scoped>

</style>
